import React from 'react';
import { Tooltip, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Bar } from 'react-chartjs-2';
import { styled } from '@mui/material/styles';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import Loading from '~/FielderElements/Loading/Loading';
import { DashboardPaper, DashboardSectionTitle } from './Dashboard.mui';
import { SmartActionLabel } from '~/FielderElements/SmartTaskTable/SmartStyles';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, ChartTooltip, Legend);

const BarChartWrapper = styled('div')({
  width: '100%',
  height: '4rem',
  maxHeight: '4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 99,
});

const TasksMonthComponent = (
  {
   lan,
   renderMonthTask,
   showAlertMonthTask,
   tasksMonth,
   taskPlanData,
 }) => {
  return (
    <DashboardPaper variant="outlined" sx={{ minHeight: 200 }}>
      <DashboardSectionTitle sx={{ mb: 2 }}>{lan.taskPlan}</DashboardSectionTitle>
      {renderMonthTask ? (
        <Grid container direction='column' alignItems='center' spacing={2}>
          <Grid size='auto'>
            {showAlertMonthTask ? (
              <Tooltip title={lan.taskPlanAlert}>
                <Typography sx={{ fontSize: 17, color: '#d0021b', fontWeight: 600 }}>
                  {`${tasksMonth.countTotalMonthTask} / ${tasksMonth.countGeneratedMonthTask} ${lan.total}`}
                </Typography>
              </Tooltip>
            ) : (
              <Typography sx={{ fontSize: 17, fontWeight: 600 }}>
                {`${tasksMonth.countTotalMonthTask} / ${tasksMonth.countGeneratedMonthTask} ${lan.total}`}
              </Typography>
            )}
          </Grid>
          <Grid size={12} sx={{ width: '100%' }}>
            <BarChartWrapper>
              <Bar
                data={taskPlanData}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  offset: true,
                  indexAxis: 'y',
                  scales: {
                    x: { stacked: true, display: false },
                    y: { stacked: true, display: false },
                  },
                  plugins: { legend: { display: false } },
                }}
              />
            </BarChartWrapper>
          </Grid>
        </Grid>
      ) : (
        <Stack alignItems='center' spacing={1} sx={{ mt: 2 }}>
          <Loading inline size='40px' thickness={1} />
          <SmartActionLabel variant='caption'>{lan.loading}</SmartActionLabel>
        </Stack>
      )}
    </DashboardPaper>
  );
};

export default TasksMonthComponent;
//Original code:
/*import React, { Component } from 'react';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Bar } from 'react-chartjs-2';
import { styled } from '@mui/material/styles';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip as ChartTooltip, Legend } from 'chart.js';
import Loading from '~/FielderElements/Loading/Loading';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, ChartTooltip, Legend);
const BarChartWrapper = styled('div')({
  width: '100%',
  height: '4rem',
  maxHeight: '4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 99,
});
class TasksMonthComponent extends Component {
	render() {
		return (
			<div className='Dashboard-tasksMonth Dashboard-box mt-3'>
				<div className='Dashboard-box-content'>
					<p className='Dashboard-box-title mb-2'>{this.props.lan.taskPlan}</p>
					{this.props.renderMonthTask ? (
						<Grid>
							<div className='row d-flex justify-content-center'>
								{this.props.showAlertMonthTask ? (
									<Tooltip title={this.props.lan.taskPlanAlert}>
										<p className='textTotalCount-Month mb-0 color-text-alert-month'>
											{`${this.props.tasksMonth.countTotalMonthTask} / ${this.props.tasksMonth.countGeneratedMonthTask} ${this.props.lan.total}`}
										</p>
									</Tooltip>
								) : (
									<p className='textTotalCount-Month mb-0'>
										{`${this.props.tasksMonth.countTotalMonthTask} / ${this.props.tasksMonth.countGeneratedMonthTask} ${this.props.lan.total}`}
									</p>
								)}
							</div>
              <BarChartWrapper>
                <Bar
                  data={this.props.taskPlanData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    offset: true,
                    indexAxis: 'y',
                    scales: {
                      x: { stacked: true, display: false },
                      y: { stacked: true, display: false },
                    },
                    plugins: { legend: { display: false } },
                  }}
                />
              </BarChartWrapper>
						</Grid>
					) : (
						<div className='row'>
							<div className='col-12 d-flex justify-content-center no-padding marginLoadingTaskMini'>
                <Loading inline size="40px" thickness={1} />
							</div>
							<div className='col d-flex justify-content-center no-padding'>{this.props.lan.loading}</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
export default TasksMonthComponent;
*/
